const state = {
  chap_index: 0,
  is_play: false,
  current_row: [],
  next_row: [],
  // video_url:"",
  definition: "sd",
  // lock_flag:-1,
  // tab_type:0,
  // current_note:0,
  scorm_url: "",
  // timeoutSwitch: false,// 防呆时长
  // addictedTime:0,
  // is_show:true,
  first_index: 0,
  // foolproofTime:0,
  // second_index:0,
  // time:0,
  // stay:false,
  // is_show:true,
  // foolproofTime:0,
  // addictedTime:0,
  is_ended: false,
  is_next: false,
};
const mutations = {
  chapIndex(state, index) {
    state.chap_index = index;
  },
  isPlay(state, isPlay) {
    state.is_play = isPlay;
  },

  currentRow(state, currentRow) {
    state.current_row = currentRow;
  },
  nextRow(state, nextRow) {
    state.next_row = nextRow;
  },

  // videoUrl(state,videoUrl){
  //   state.next_row=videoUrl
  // },
  Definition(state, Definition) {
    state.definition = Definition;
  },
  // lockFlag(state,lockFlag){
  //   state.lock_flag=lockFlag;
  // },
  // tabType(state, tabType) {
  //   state.tab_type = tabType;
  // },
  // currentNote(state, currentNote) {
  //   state.current_note = currentNote;
  // },
  scormUrl(state, scormUrl) {
    state.scorm_url = scormUrl;
  },
  // timeoutSwitch(state, timeoutSwitch) {
  //   state.timeoutSwitch = timeoutSwitch;
  // },
  // addictedTime(state, addictedTime) {
  //   state.addictedTime = addictedTime;
  // },
  // is_show(state, is_show) {
  //   state.is_show = is_show;
  // },
  firstIndex(state, firstIndex) {
    state.first_index = firstIndex;
  },
  // foolproofTime(state, foolproofTime) {
  //   state.foolproofTime = foolproofTime;
  // },

  // time(state, time) {
  //   state.time = time;
  // },
  is_ended(state, is_ended) {
    state.is_ended = is_ended;
  },
  is_next(state, is_next) {
    state.is_next = is_next;
  },
  // watched(state, watched) {
  //   state.watched = watched;
  // },
  // foolproofTime(state, foolproofTime) {
  //   state.foolproofTime = foolproofTime;
  // },
};
const actions = {
  chapIndex: ({ commit }) => commit("chapIndex"),
  isPlay: ({ commit }) => commit("isPlay"),

  currentRow: ({ commit }) => commit("currentRow"),
  nextRow: ({ commit }) => commit("nextRow"),
  // videoUrl:({
  //   commit
  // })=>commit("videoUrl"),
  Definition: ({ commit }) => commit("Definition"),
  // lockFlag:({
  //   commit
  // })=>commit("lockFlag"),
  // tabType: ({
  //   commit
  // }) => commit("tabType"),
  // currentNote: ({
  //   commit
  // }) => commit("currentNote"),
  scormUrl: ({ commit }) => commit("scormUrl"),
  // timeoutSwitch:({
  //   commit
  // }) => commit("timeoutSwitch"),
  // addictedTime:({
  //   commit
  // }) => commit("addictedTime"),
  // is_show:({
  //   commit
  // }) => commit("is_show"),
  firstIndex: ({ commit }) => commit("firstIndex"),
  // foolproofTime: ({
  //   commit
  // }) => commit("foolproofTime"),

  // time: ({
  //   commit
  // }) => commit("time"),
  is_ended: ({ commit }) => commit("is_ended"),
  is_next: ({ commit }) => commit("is_next"),
  // foolproofTime: ({
  //   commit
  // }) => commit("foolproofTime"),
  // watched: ({
  //   commit
  // }) => commit("watched"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
